import { jsx as o } from "react/jsx-runtime";
import { cva as n } from "class-variance-authority";
import { forwardRef as s } from "react";
import { twMerge as g } from "tailwind-merge";
import { cn as c } from "./index22.mjs";
const l = n("border-none", {
  variants: {
    thickness: {
      thin: "h-[2px]",
      thick: "h-[4px]"
    },
    color: {
      light: "bg-gray-300",
      dark: "bg-gray-800",
      primary: "bg-blue-600",
      secondary: "bg-green-600"
    },
    marginY: {
      none: "my-0",
      small: "my-2",
      medium: "my-4",
      large: "my-6"
    }
  },
  defaultVariants: {
    thickness: "thin",
    color: "light",
    marginY: "medium"
  }
}), d = s(({ thickness: r, color: i, marginY: m, className: e, ...t }, a) => /* @__PURE__ */ o("hr", { ref: a, className: g(c(l({ thickness: r, color: i, marginY: m })), e), ...t }));
d.displayName = "Divider";
export {
  d as Divider
};
